import { cdnImageUrl } from "@Src_main/utils/generalUtils";
import resourceUrl from "../util/makeUrl";

/**
 * This is specific to the Venia store-front sample data.
 */
export const DEFAULT_WIDTH_TO_HEIGHT_RATIO = 4 / 5;
export const imageWidths = new Map(Object.entries({
  ICON: 40,
  THUMBNAIL: 80,
  SMALL: 160,
  REGULAR: 320,
  LARGE: 640,
  LARGER: 960,
  XLARGE: 1280,
  XXLARGE: 1600,
  XXXLARGE: 2560
}));
export const generateUrl = (imageURL, mediaBase) => (width, height) => resourceUrl(imageURL, {
  type: mediaBase,
  width,
  height,
  fit: "cover"
});
export const generateUrlFromContainerWidth = function (imageURL, containerWidth) {
  let type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "image-product";
  let ratio = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_WIDTH_TO_HEIGHT_RATIO;
  const intrinsicWidth = window.devicePixelRatio * containerWidth;

  /**
   * Find the best width that is closest to the intrinsicWidth.
   */
  const actualWidth = Array.from(imageWidths, _ref => {
    let [, value] = _ref;
    return value;
  }).reduce((prev, curr) => {
    if (prev) {
      return Math.abs(intrinsicWidth - curr) < Math.abs(intrinsicWidth - prev) ? curr : prev;
    } else {
      return curr;
    }
  }, null);
  return generateUrl(imageURL, type)(actualWidth, actualWidth / ratio);
};
export const generateSrcset = (imageURL, type, ratio) => {
  if (!imageURL || !type) return "";
  const imageRatio = ratio || DEFAULT_WIDTH_TO_HEIGHT_RATIO;
  const generateSrcsetUrl = generateUrl(cdnImageUrl(imageURL), type);
  return Array.from(imageWidths, _ref2 => {
    let [, value] = _ref2;
    return value;
  }).map(width => "".concat(generateSrcsetUrl(width, Math.round(width / imageRatio)), " ").concat(width, "w")).join(",\n");
};